import resources from '../../apps/benefit/resources/types.json';

export const UnhealthyApp = () => {
  return (
    <section className="section-main section-full unhealthy-page">
      <div className="container">
        <div className="empty-state es-unhealthy-page">
          <div className="es-image"></div>
          <h3>{resources.emptyState.unhealthy.title}</h3>
          <p>
            {resources.emptyState.unhealthy.text}{' '}
            <a href={resources.emptyState.unhealthy.link}>
              {resources.emptyState.unhealthy.linkLabel}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};
